import React from "react"
import { AppAuthCheck } from "../../../Components/Common/AuthCheck/AppAuthCheck"
import { AIModelList } from "../../../Components/Views/Dashboard/Sections/AppDetail/AIModels/Prediction/AIModelList"
import { AppDetailRouteComponentProps } from "../../RouteProps"

export function AppModelListRoute({ match }: AppDetailRouteComponentProps) {
    return (
        <AppAuthCheck {...match.params} scope="ai:view">
            <AIModelList {...match.params} />
        </AppAuthCheck>
    )
}
